import React, { useState, useEffect, useContext, useMemo } from "react";
import { useNavigate } from "react-router-dom";
import Sidebar from "../components/Sidebar";
import { UserContext } from "../services/UserContext";
import "./FinanzasPage.css";

export default function FinanzasPage() {
  const navigate = useNavigate();
  const { user } = useContext(UserContext);
  const [token, setToken] = useState(null);
  const [profesionales, setProfesionales] = useState([]);
  const [profesionalId, setProfesionalId] = useState(null);

  useEffect(() => {
    const storedToken = localStorage.getItem("token");
    if (!storedToken) {
      navigate("/login");
    } else {
      setToken(storedToken);
      fetchProfesionales(storedToken);
    }
  }, [navigate]);

  useEffect(() => {
    if (!token || !user) return;
    if (user.role === "profesional") {
      setProfesionalId(user.profesional?.id || null);
    }
  }, [token, user]);

  const fetchProfesionales = async (token) => {
    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_URL || "http://localhost:8000"}/api/profesionales`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      const data = await response.json();
      if (data.success) {
        setProfesionales(data.data.filter((p) => p.activo));
      }
    } catch (err) {
      console.error("Error al cargar profesionales:", err);
    }
  };

  const profesionalActual = useMemo(
    () => profesionales.find((p) => String(p.id) === String(profesionalId)),
    [profesionalId, profesionales]
  );

  if (!token) return <div>Cargando...</div>;

  return (
    <div className="finanzas-container">
      <Sidebar />
      <div className="finanzas-content">
        <div className="finanzas-header">
          <h1>💰 Finanzas y Reportes</h1>
          <p className="finanzas-subtitle">Reportes e ingresos disponibles en funciones premium</p>
          {user?.role === "admin" ? (
            <select
              className="select-profesional"
              value={profesionalId || ""}
              onChange={(e) => {
                const nextId = e.target.value ? Number(e.target.value) : null;
                setProfesionalId(nextId);
              }}
            >
              <option value="">Todos los profesionales</option>
              {profesionales.map((p) => (
                <option key={p.id} value={p.id}>
                  {p.apellido}, {p.nombre}
                </option>
              ))}
            </select>
          ) : (
            <p className="finanzas-subtitle">
              Profesional: {profesionalActual ? `${profesionalActual.apellido}, ${profesionalActual.nombre}` : "Mi cuenta"}
            </p>
          )}
        </div>

        <div className="finanzas-grid">
          {/* Tarjeta Balance Diario — premium */}
          <div className="finanzas-card finanzas-card-locked">
            <div className="card-icon">📅</div>
            <h2>Balance Diario</h2>
            <p>Ver cobros del día actual (función premium)</p>
            <button className="card-btn" onClick={() => navigate("/premium")}>
              Ver funciones premium
            </button>
          </div>

          {/* Tarjeta Balance Semanal — premium */}
          <div className="finanzas-card finanzas-card-locked">
            <div className="card-icon">📊</div>
            <h2>Balance Semanal</h2>
            <p>Ingresos, gastos y margen semanal (función premium)</p>
            <button className="card-btn" onClick={() => navigate("/premium")}>
              Ver funciones premium
            </button>
          </div>

          {/* Tarjeta Gestión de Gastos — premium */}
          <div className="finanzas-card finanzas-card-locked">
            <div className="card-icon">💸</div>
            <h2>Gestión de Gastos</h2>
            <p>Registrá sueldos, insumos y servicios (función premium)</p>
            <button className="card-btn" onClick={() => navigate("/premium")}>
              Ver funciones premium
            </button>
          </div>
        </div>

        <div className="finanzas-info">
          <div className="info-box">
            <h3>ℹ️ Finanzas — consulta</h3>
            <ul>
              <li>📅 <strong>Balance Diario:</strong> Consultá los cobros del día (función premium).</li>
              <li>📊 <strong>Balance Semanal:</strong> Resumen de ingresos y gastos (función premium).</li>
              <li>💸 <strong>Gastos:</strong> La gestión completa de finanzas es una función premium.</li>
            </ul>
            <button
              type="button"
              className="card-btn"
              style={{ marginTop: 12 }}
              onClick={() => navigate("/premium")}
            >
              Ver funciones premium
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
